import { useRef, useState } from "react";
import { MdOutlineKeyboardDoubleArrowLeft, MdOutlineKeyboardDoubleArrowRight } from "react-icons/md";
import PropTypes from 'prop-types';

const SectionPaginator = ({ heading, contents }) => {
    const ref = useRef(null);
    const [currentItemIndex, setCurrentItemIndex] = useState(0);
    const breakPoint = 4;

    const getVisibleIndexes = () => {
        if (contents.length <= breakPoint) {
            return Array.from({ length: contents.length }, (_, i) => i);
        }
        
        const startIndex = Math.max(
            Math.min(currentItemIndex - Math.floor(breakPoint / 2), contents.length - breakPoint),
            0
        );

        return Array.from({ length: breakPoint }, (_, i) => startIndex + i);
    };

    return (
        <div className="flex flex-col gap-5 items-center w-full">
            <div className="flex relative items-stretch justify-between w-full">
                <h1 ref={ref} className="text-red-500 text-2xl font-semibold border-b-2 border-red-500 py-4">{heading}</h1>
                <div className="flex-1 w-full flex items-center justify-end border-b-2 border-b-neutral-700 py-4">
                    <div className="flex items-center gap-3 cursor-pointer select-none">
                        <MdOutlineKeyboardDoubleArrowLeft
                            size={25}
                            onClick={() => { currentItemIndex > 0 && setCurrentItemIndex(prev => prev - 1); }}
                        />
                        {getVisibleIndexes().map((index) =>
                            <span
                                key={index}
                                className={`text-cyan-400 text-lg hover:text-cyan-600 transition-all p-2 rounded ${index === currentItemIndex ? "bg-cyan-400 text-neutral-700" : ""}`}
                                onClick={() => setCurrentItemIndex(index)}
                            >
                                {index + 1}
                            </span>
                        )}
                        <MdOutlineKeyboardDoubleArrowRight
                            size={25}
                            onClick={() => { currentItemIndex < (contents?.length - 1) && setCurrentItemIndex(prev => prev + 1); }}
                        />
                    </div>
                </div>
            </div>
            <div className="flex w-full">
                {contents && contents[currentItemIndex]}
            </div>
        </div>
    );
};

SectionPaginator.propTypes = {
    heading: PropTypes.string,
    contents: PropTypes.array
};

export default SectionPaginator;
